module.exports = __webpack_public_path__ + "img/c02_unitslingerchampion_Normal_ua.8b1d4a94.webp";